import { Navigate } from 'react-router-dom';

import useAuthStore from '../../store/auth';
import { getTokensLocalStorage } from '../../services';

interface ProtectedRoutesPros {
  children: JSX.Element;
}

export const ProtectedRoutes = ({ children }: ProtectedRoutesPros) => {
  const signed = useAuthStore(state => state.signed);
  const hasTokens = getTokensLocalStorage();

  if (!signed || !hasTokens || hasTokens === '') {
    return <Navigate to="/" />;
  }

  return children;
};
